module.exports = __webpack_public_path__ + "static/media/custom-07.755efab5.jpg";